<template>
  <div class="app-container" style="display: block; height: 100vh">
    <el-row class="comp-row">
      <el-col :span="12" class="comp-title">待办事项</el-col>
      <el-col :span="12" class="text-right"><i class="el-icon-more"></i></el-col>
      <el-divider></el-divider>
     <div style="font-size: 18px; text-align:center">暂无数据</div>
    </el-row>
    
    <el-row class=comp-row>
      <el-col :span="12" class="comp-title">已办事项</el-col>
      <el-col :span="12" class="text-right"><i class="el-icon-more"></i></el-col>
      <el-divider></el-divider>
       <div style="font-size: 18px;text-align:center">暂无数据</div>
    </el-row>
  </div>
</template>

<script>
import { getCodeImg } from "@/api/login";
import Cookies from "js-cookie";

export default {
  name: "index",
  data() {
    return {
      
    };
  },
  watch: {
   
  },
  created() {
   
  },
  methods: {
    
  }
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
.comp-row {
  .comp-title{
    font-size: 18px;
    font-weight: bold;
    padding-left: 20px;
  }
  .text-right {
    padding-right: 20px;
  }
  &:not(:last-child) {
    height: 50%;
  }
  margin-bottom: 20px;
  margin-top: 10px;
  .el-divider--horizontal {
    margin: 36px 0;
  }
}

</style>
